import React from 'react';
import styles from './MealControl.module.css';
import Checkbox from '../../elemets/Checkbox/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { addMealRedux, onChangeMealControlRedux } from '../../store/slices/menuSlice';

// Checkbox({ ifSelected, handleClick })

export default function MealControl({ mealName }) {
  const dispatch = useDispatch();

  const menuObject = useSelector((state) => state.menu.menuDay);
  const menuObjectMeal = useSelector((state) => state.menu.menuDay[mealName]);
  const menuAll = useSelector((state) => state.showMenu.menu);

  // console.log(menuMealRepeatMenu);
  // console.log(mealName);
  // console.log(menuObject.dayNumber);

  // dispatch(addMealRedux(mealName));

  const getYesterdaysValue = (menuAll, dayNumber, mealName) => {
    const menuKeys = Object.keys(menuAll);

    let allow = false;

    for (let index = 0; index < menuKeys.length; index++) {
      const menuObject = menuAll[menuKeys[index]];

      // console.log(menuObject.dayNumber);
      // console.log(
      //   menuObject.dayNumber === Number(dayNumber) - 1 && menuObject[mealName].repeatMenu,
      // );
      // console.log('Number(dayNumber) - 1 === ', Number(dayNumber) - 1);
      // console.log(Number(menuObject.dayNumber) === Number(dayNumber) - 1);
      // console.log('menuObject[mealName].repeatMenu  ==== ', menuObject[mealName].repeatMenu);

      if (
        Number(menuObject.dayNumber) === Number(dayNumber) - 1 &&
        menuObject[mealName].repeatMenu
      ) {
        allow = true;
      }
    }
    return allow;
  };

  const onChangeTwoServings = (value) => {
    // console.log(value);
    if (menuObjectMeal.menuText.length) {
      alert(`Вам потрібно видалити всь "${menuObjectMeal.title}" щоб змінити це значення.`);
      return;
    }
    dispatch(onChangeMealControlRedux({ mealName, item: 'twoServings', value }));
    if (value) {
      dispatch(onChangeMealControlRedux({ mealName, item: 'repeatMenu', value: false }));
    }
  };

  const onChangeRepeatMenu = (value) => {
    // console.log(value);
    if (menuObjectMeal.menuText.length) {
      alert(`Вам потрібно видалити всь "${menuObjectMeal.title}" щоб змінити це значення.`);
      return;
    }
    if (menuObject.dayNumber < 2) {
      alert(`Це значення можна змінювати починаючи з другогодня харчування`);
      return;
    }
    if (value && getYesterdaysValue(menuAll, menuObject.dayNumber, mealName)) {
      alert(
        `Не можливо вткористати вчорашній "${menuObjectMeal.title}" тому що він використовує "${menuObjectMeal.title}" позавчерашній`,
      );
      return;
    }
    dispatch(onChangeMealControlRedux({ mealName, item: 'repeatMenu', value }));
    if (value) {
      dispatch(onChangeMealControlRedux({ mealName, item: 'twoServings', value: false }));
    }
  };

  return (
    <div
      className={
        menuObjectMeal.menuText.length
          ? styles.meal_control_wrapper + ' ' + styles.meal_control_wrapper_noActive
          : styles.meal_control_wrapper
      }>
      <div className={'df aic gap_10'}>
        <Checkbox ifSelected={menuObjectMeal.twoServings} handleClick={onChangeTwoServings} />
        Страва на 2 порції
      </div>

      <div className={'df aic gap_10'}>
        <Checkbox ifSelected={menuObjectMeal.repeatMenu} handleClick={onChangeRepeatMenu} />
        {menuObjectMeal.repeatMenuTitle}
      </div>
    </div>
  );
}
